import React from "react";
import { isNil, omit, assoc, values } from "ramda";
import PropTypes from "prop-types";
import { Checkbox } from "../../native";
import { Error } from "../../service";

class CheckboxList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      values: {}
    };

    this.triggerChange = this.triggerChange.bind(this);
  }

  getChildContext() {
    return {
      formikCheckboxList: {
        triggerChange: this.triggerChange,
        values: this.state.values
      }
    };
  }

  triggerChange(index, value, checked) {
    const { formik } = this.context;
    const { values: currentValues } = this.state;
    const nextValues = !checked
      ? omit([index], currentValues)
      : assoc(index, value, currentValues);

    this.setState({ values: nextValues });

    formik.setValues({
      ...formik.values,
      [this.props.name]: values(nextValues)
    });
  }

  renderChildren() {
    return typeof this.props.children !== "function"
      ? this.props.children
      : this.props.children(this.state.values, this.triggerChange);
  }

  render() {
    const { errors, touched } = this.context.formik;
    const isDirty = touched[this.props.name];
    const error = errors[this.props.name];

    return (
      <div>
        {this.renderChildren()}
        {isDirty && error && <Error>{error}</Error>}
      </div>
    );
  }
}

CheckboxList.contextTypes = {
  formik: PropTypes.object
};

CheckboxList.childContextTypes = {
  formikCheckboxList: PropTypes.object
};

CheckboxList.Item = class extends React.Component {
  renderChildren() {
    const { triggerChange, values } = this.context.formikCheckboxList;
    const currentValue = values[this.props.index];
    const checked = !isNil(currentValue);

    return typeof this.props.children !== "function"
      ? this.props.children
      : this.props.children(currentValue, checked, value =>
          triggerChange(this.props.index, value, true)
        );
  }

  render() {
    const { triggerChange, values } = this.context.formikCheckboxList;

    return (
      <div>
        <Checkbox
          title={this.props.title}
          name={this.props.name}
          onChange={e =>
            triggerChange(this.props.index, e.target.name, e.target.checked)
          }
          checked={!isNil(values[this.props.index])}
        />
        {this.renderChildren()}
      </div>
    );
  }
};

CheckboxList.Item.contextTypes = {
  formikCheckboxList: PropTypes.object
};

export default CheckboxList;



// WEBPACK FOOTER //
// ./src/components/generic/form/formik/CheckboxList/index.js